@if (!showIncidentcreator) {
  <div class="globe-action-drawer"   >
    <div class="action-icons" [class.open]="drawerOpen">
      @for (action of actions; track action) {
        @if (!action.visible || action.visible()) {
          <button
            class="action-btn"
            [title]="action.title"
            (click)="action.action()"
            >
            <i [class]="action.icon"></i>
          </button>
        }
      }
    </div>
    <!-- Saved Views as round buttons -->
    <div class="saved-views-row">
      <div class="saved-views-list">
        <!-- Use vertical stack -->
        <div class="saved-views-column">
          <!-- Remaining items displayed above the first 4 when expanded -->
          @if (drawerExpanded) {
            <div class="saved-views-extra-row">
              @for (view of savedViews.slice(4); track view) {
                <button class="saved-view-btn"
                  [attr.title]="'Click: Zoom | Double Click: Set Default | Right Click: Delete'"
                  (click)="onSelectSavedView(view)" (contextmenu)="openDeleteModal(view, $event)"
                  (dblclick)="openUpdateModal(view, $event)">
                  <div class="saved-view-content">
                    <span class="view-name">{{ view.name }}</span>
                    @if (view.isDefault) {
                      <i class="fa-solid fa-home session-header-icon"></i>
                    }
                  </div>
                </button>
              }
            </div>
          }
          <!-- First 4 items always shown -->
          <div class="saved-views-main-row">
            @for (view of savedViews.slice(0, 4); track view) {
              <button class="saved-view-btn"
                [attr.title]="'Click: Zoom | Double Click: Set Default | Right Click: Delete'"
                (click)="onSelectSavedView(view)" (contextmenu)="openDeleteModal(view, $event)"
                (dblclick)="openUpdateModal(view, $event)">
                <div class="saved-view-content">
                  <span class="view-name">{{ view.name }}</span>
                  @if (view.isDefault) {
                    <i class="fa-solid fa-home session-header-icon"></i>
                  }
                </div>
              </button>
            }
          </div>
        </div>
        <!-- Toggle button with icon -->
        @if (savedViews.length > 4) {
          <button class="view-all-btn" (click)="toggleViewAll()">
            <i class="fa-solid fa-grip"></i>
          </button>
        }
        @if (!showIncidentcreator) {
          <button class="add-btn" (click)="onAddNew()" title="Add New View">
            <i class="fa fa-plus"></i>
          </button>
        }
      </div>
    </div>
    <button class="wrench-btn" (click)="toggleDrawer()" title="Tools">
      <i class="fa fa-wrench"></i>
    </button>
  </div>
}

<div class="tool-palettes">
  @if (showLocationPalette) {
    <app-markers-palette (markerSelected)="onMarkerSelected($event)" (close)="onCloseLocationPalette()"
    ></app-markers-palette>
  }

  @if (showIncidentcreator) {
    <app-incident-creator-button
    (toolbarClosed)="onCloseIncidentcreator()"></app-incident-creator-button>
  }
</div>